module.exports = __webpack_public_path__ + "static/media/ico-new-tags.57795795.png";